function ProgressBar({ value }) {
  return (
    <div className="h-1.5 overflow-hidden rounded-full bg-slate-200">
      <div
        className="h-full rounded-full bg-blue-600 transition-all duration-1000"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
export default ProgressBar;
